import { AESCipherSIVNonce96 } from '../../base/cipher/aes';
import { AbstractSelfAccountKeyring } from '../../keyring/account_base';
import { PeerAccountKeyring } from '../../keyring/account_peer';
import { AbstractCryptoConfig } from '../base';
import { RegisterChallengeConfigDumpArgs, RegisterChallengeConfigLoadArgs } from './args';
import { concatByteArray, makeInfoByteArray } from '../../utility';
import { HKDFKeyGeneratorV2 } from '../../base/key/kdf';
import { Curve25519SharedSecretGenerator } from '../../base/key/dh';
import { CryptoUpgrade } from '../feature';

export class RegisterChallengeConfigV2 extends AbstractCryptoConfig<
  RegisterChallengeConfigLoadArgs,
  RegisterChallengeConfigDumpArgs
> {
  constructor(cu: CryptoUpgrade) {
    super(2, cu);
  }

  public load(args: RegisterChallengeConfigLoadArgs): Promise<Uint8Array> {
    return this.derive_key(
      args.peer_kr.get_shared_secret(PeerAccountKeyring.SS_PEER_MLKEM1024),
      args.self_kr,
      args.peer_kr
    ).then((derive_key) => {
      return AESCipherSIVNonce96.decrypt(args.cipher.slice(this.version.byteLength), derive_key);
    });
  }

  public dump(args: RegisterChallengeConfigDumpArgs): Promise<Uint8Array> {
    return this.derive_key(
      args.peer_kr.get_shared_secret(PeerAccountKeyring.SS_SELF_MLKEM1024),
      args.self_kr,
      args.peer_kr
    ).then((derive_key) => {
      return AESCipherSIVNonce96.encrypt(
        args.plain,
        derive_key,
        undefined,
        undefined,
        this.version
      );
    });
  }

  public derive_key(
    shared_secret: Uint8Array,
    self_kr: AbstractSelfAccountKeyring,
    peer_kr: PeerAccountKeyring
  ) {
    return HKDFKeyGeneratorV2.new_key(
      64,
      concatByteArray(
        Curve25519SharedSecretGenerator.new_key(
          self_kr.get_secret_key(AbstractSelfAccountKeyring.CURVE25519),
          peer_kr.get_public_key(AbstractSelfAccountKeyring.CURVE25519)
        ),
        shared_secret
      ),
      new Uint8Array([]),
      makeInfoByteArray(['register-challenge'])
    );
  }
}
